import React, { useEffect } from 'react';
import './psbienydes.css';
import { psbienydes } from '../../json/psbienydes';

const Psbienydes = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa Apoyo Para el Bienestar y Desarrollo</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Descripción del Programa</h5>

                <p>
                Contribuir a mejorar el ingreso de la población en situación de marginación, pobreza extrema y rezago social en las 12 regiones del Estado de Hidalgo, de acuerdo al Plan Estatal de Desarrollo 2022-2028.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                El programa Estatal Apoyos para el Bienestar y Desarrollo tiene como finalidad coadyuvar a mejorar el ingreso de la población hidalguense que habite en localidades de alta y muy alta marginación, en situación de pobreza extrema, de rezago social y población indígena de las zonas de atención prioritaria de la entidad. Este grupo de población requiere de mayores apoyos gubernamentales, ya que han sido históricamente olvidados y es prioridad del Gobierno Estatal cambiar la dirección en la ejecución de la política social, la cual ahora se encamina en atender “Primero a los Pobres”.
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a mejorar el ingreso de la población en situación de marginación, pobreza extrema y rezago social en las 12 regiones del Estado de Hidalgo, de acuerdo al Plan Estatal de Desarrollo 2022-2028.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Población Objetivo</h5>
                <p>
                Personas hidalguenses de 30 a 64 años de edad que habiten en las localidades de alta y muy alta marginación, en situación de pobreza extrema y/o de rezago social.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Cobertura</h5>
                <p>
                El Programa Estatal “Apoyo para el Bienestar y el Desarrollo” priorizará la distribución equitativa de los apoyos en las 12 regiones del Estado de Hidalgo, o en los 22 municipios y localidades de atención prioritaria indígena de la entidad, de acuerdo con el Plan Estatal de Desarrollo 2022-2028.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Inclusión y Desarrollo<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Ing. Julián Nochebuena Hernández<br />                    
                  </li>
                  <li>Lic. Francisco Alberto Rico Romo<br />
                  </li>
                  <li>Ing. Juan Roberto Lazcano Trejo<br />
                  </li>
                  <li>Lic. Rosa Isela Ramírez Romero<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                (771) 717 8000 Ext. 8948, 8950, 8933, 8538
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2023/ROPS_BienyDes_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2023/Conv_BienyDes_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Convocatoria</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                //href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/folios/2023/Folios_Beneficiarios_Bien_y_Des_Madres_Solt.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                //href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/folios/2023/Folios_BienestaryDesarrollo2829sep23.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                //href='transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Padrones/Pad_Parc_Bien_Desarr.pdf'
                //target='_blank' se quito este enlace porque lo van a revisar
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/indicadores/2023/Est_BienyDes.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Estadisticas</a></strong></h5>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psbienydes;